import { render, staticRenderFns } from "./ListMenuOptionsAssigned.vue?vue&type=template&id=b81a2eda"
import script from "./ListMenuOptionsAssigned.vue?vue&type=script&lang=js"
export * from "./ListMenuOptionsAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports